import { request } from '../../helpers'

export default {
  async getCustomerAccountStatus(id) {
    if (!id) {
      console.warn('API: getCustomerAccountStatus: id is not defined!')
      return
    }
    return (await request({ url: `customers/${id}/account_status` })).data
  },

  // customers
  async listCustomers({ queryParameters = {}, expand = [] } = {}) {
    return (
      await request({
        url: 'customers',
        queryParameters,
        expand,
      })
    ).data
  },

  async retrieveCustomer(id) {
    if (!id) {
      console.warn('API: retrieveCustomer: id is not defined!')
      return
    }
    return (await request({ url: `customers/${id}` })).data
  },

  async addChildDependant(id, { data = {} } = {}) {
    if (!id) {
      console.warn('API: addChildDependant: id is not defined!')
      return
    }
    return (
      await request({ method: 'POST', url: `customers/${id}/add_child`, data })
    ).data
  },

  async changeEmail(id, data = {}) {
    if (!id) {
      console.warn('API: changeEmail: id is not defined!')
      return
    }
    return (
      await request({
        method: 'POST',
        url: `customers/${id}/change_email`,
        data,
      })
    ).data
  },

  async updateCustomerPassword(id, data = {}) {
    if (!id) {
      console.warn('API: updateCustomerPassword: id is not defined!')
      return
    }
    return (
      await request({
        method: 'POST',
        url: `customers/${id}/change_password`,
        data,
      })
    ).data
  },

  async updateCustomer(id, data = {}) {
    if (!id) {
      console.warn('API: updateCustomer: id is not defined!')
      return
    }
    return (await request({ method: 'PATCH', url: `customers/${id}`, data }))
      .data
  },

  async updateCustomerParticipation(id, data = {}) {
    if (!id) {
      console.warn('API: updateCustomerParticipation: id is not defined!')
      return
    }
    return (
      await request({
        method: 'PUT',
        url: `/customers/${id}/participation`,
        data,
      })
    ).data
  },

  async addChildCustomer({ id, data = {} }) {
    if (!id) {
      console.warn('API: addChildCustomer: id is not defined!')
      return
    }
    return (
      await request({ method: 'POST', url: `customers/${id}/add_child`, data })
    ).data
  },

  async addFamilyManager({ data = {} }) {
    return (await request({ method: 'POST', url: 'family_invites', data })).data
  },

  async listFamilyInvites({ queryParameters = {} } = {}) {
    return (
      await request({
        method: 'GET',
        url: 'family_invites',
        queryParameters,
      })
    ).data
  },

  // notifications
  async getNotificationPreferences(customerId) {
    if (!customerId) {
      console.warn(
        'API: getNotificationPreferences: customerId is not defined!',
      )
      return
    }
    return (
      await request({
        method: 'GET',
        url: `customers/${customerId}/notification_preferences`,
      })
    ).data
  },
  async updateNotificationPreferences(
    customerId,
    notificationPreferencesId,
    { data = {} } = {},
  ) {
    if (!customerId) {
      console.warn(
        'API: updateNotificationPreferences: customerId is not defined!',
      )
      return
    }
    return (
      await request({
        method: 'PATCH',
        url: `customers/${customerId}/notification_preferences/${notificationPreferencesId}`,
        data,
      })
    ).data
  },

  // payments
  async getInvoices({ queryParameters = {}, expand = [] } = {}) {
    return (await request({ url: 'invoices', queryParameters, expand })).data
  },
  async retrieveInvoice(id, { expand = [] } = {}) {
    return (await request({ url: `invoices/${id}`, expand })).data
  },
  async getPaymentMethods() {
    return (await request({ url: 'payment_methods' })).data
  },
  async deletePaymentMethod(id) {
    return (await request({ url: `payment_methods/${id}`, method: 'DELETE' }))
      .data
  },
  async getPaymentProcessors() {
    return (await request({ url: 'payment_processors' })).data
  },

  // sms
  async getSmsAccount(customerId) {
    if (!customerId) {
      console.warn('API: getSmsAccount: customerId is not defined!')
      return
    }
    return (await request({ url: `customers/${customerId}/sms_account` })).data
  },
  async updateSmsAccount(customerId, { data = {} } = {}) {
    if (!customerId) {
      console.warn('API: getSmsAccount: customerId is not defined!')
      return
    }
    return (
      await request({
        method: 'PUT',
        url: `customers/${customerId}/sms_account`,
        data,
      })
    ).data
  },
  async verifySmsAccount(id, data) {
    if (!id || !data) {
      console.warn('API: verifySmsAccount: id or data is not defined!')
      return
    }
    return (
      await request({
        method: 'POST',
        url: `customers/${id}/sms_account/verify`,
        data,
      })
    ).data
  },
  async unregisterEvent(id, { data = {} } = {}) {
    if (!id) {
      console.warn('API: unregisterEvent: id is not defined!')
      return
    }
    return (
      await request({ method: 'POST', url: `events/${id}/unregister`, data })
    ).data
  },

  // customer forms
  async listCustomerForms({ expand = [], queryParameters = {} }) {
    return (
      await request({
        url: 'customer_forms',
        queryParameters,
        expand,
      })
    ).data
  },
  async listCustomerFields({ queryParameters = {} }) {
    return (await request({ url: 'customer_fields', queryParameters })).data
  },
  async retrieveCustomerField(id) {
    return (
      await request({
        url: `customer_fields/${id}`,
      })
    ).data
  },
  async listCustomerFieldValues({ queryParameters = {} } = {}) {
    return (await request({ url: 'customer_field_values', queryParameters }))
      .data
  },
  async retrieveCustomerFieldValue(id, { expand = [] } = {}) {
    return (
      await request({
        url: `customer_field_values/${id}`,
        expand,
      })
    ).data
  },
  async updateCustomerFieldValue(id, data = {}) {
    return (
      await request({
        method: 'PUT',
        url: `customer_field_values/${id}`,
        data,
      })
    ).data
  },

  async createCustomerFieldValue(data = {}) {
    return (
      await request({
        method: 'POST',
        url: 'customer_field_values',
        data,
      })
    ).data
  },

  // waivers
  async listWaivers({ queryParameters = {}, expand = [] } = {}) {
    return (
      await request({
        url: 'waivers',
        queryParameters,
        expand,
      })).data
  },

  async listWaiverAgreements({ queryParameters = {}, expand = [] } = {}) {
    return (
      await request({ url: 'waiver_agreements', queryParameters, expand })
    ).data
  },
  async retrieveWaiver(id) {
    if (!id) {
      console.warn('API: retrieveWaiver: id is not defined!')
      return
    }
    return (await request({ url: `waivers/${id}` })).data
  },
  async retrieveWaiverAgreement(id, { expand = [] }) {
    if (!id) {
      console.warn('API: retrieveWaiver: id is not defined!')
      return
    }
    return (await request({ url: `waiver_agreements/${id}`, expand })).data
  },

  async listCustomerMemberships({ queryParameters = {}, expand = [] } = {}) {
    return (
      await request({ url: 'customer_memberships', queryParameters, expand })
    ).data
  },

  // reservations
  async listReservations({ queryParameters = {}, expand = [] } = {}) {
    return (
      await request({ url: 'recurring_reservations', queryParameters, expand })
    ).data
  },
  async retrieveReservation(id, { expand = [] } = {}) {
    if (!id) {
      console.warn('API: retrieveReservation: id is not defined!')
      return
    }
    return (await request({ url: `recurring_reservations/${id}`, expand })).data
  },
  async listUnavailableUpcomingReservations(id, { expand = [] } = {}) {
    if (!id) {
      console.warn(
        'API: listUnavailableUpcomingReservations: id is not defined!',
      )
      return
    }
    return (
      await request({
        url: `recurring_reservations/${id}/unavailable_upcoming_events`,
        expand,
      })
    ).data
  },
  async updateReservation(id, { data = {} } = {}) {
    if (!id) {
      console.warn('API: updateReservation: id is not defined!')
      return
    }
    return (
      await request({
        method: 'PATCH',
        url: `recurring_reservations/${id}`,
        data,
      })
    ).data
  },

  // policies
  async listPolicies({ expand = [] }) {
    return (await request({ url: 'policies', expand })).data
  },
  async listPolicyAgreements({ expand = [] }) {
    return (await request({ url: '/policy_agreements', expand })).data
  },
  async retrievePolicy({ id, expand = [] } = {}) {
    if (!id) {
      console.warn('API: retrievePolicy: id is not defined!')
      return
    }
    return (await request({ url: `policies/${id}`, expand })).data
  },
  async createPolicyAgreement({ data = {} } = {}) {
    return await request({
      method: 'POST',
      url: 'policy_agreements',
      data,
    })
  },

  async sendEmailVerification(customerId) {
    if (!customerId) {
      console.warn('API: sendEmailVerification: customerId is not defined!')
      return
    }

    return (
      await request({
        method: 'POST',
        url: `customers/${customerId}/resend_email_confirmation`,
      })
    ).data
  },

  // membership sharing
  async getCustomerMembershipSharingStatus(id, { expand = [] } = {}) {
    if (!id) {
      console.warn('API: getCustomerMembershipSharingStatus: id is not defined!')
      return
    }
    return (await request({
      url: `customer_memberships/${id}/share_status`,
      expand,
    })).data
  },
  async shareCustomerMembership(id, { data = {} } = {}) {
    if (!id) {
      console.warn('API: shareCustomerMembership: id is not defined!')
      return
    }
    return (await request({
      method: 'POST',
      url: `customer_memberships/${id}/share`,
      data,
    })).data
  },

}
